import React from 'react'
import {
    Input
} from 'reactstrap'

const ContentComponent = (props) => {
    return (
        <Input
            name={props.name || "undefined"}
            disabled={props.disabled || false}
            value={props.value || ""}
            onChange={props.onChange}
            type="textarea"
            placeholder={props.placeholder}
        />
    )
}

export default ContentComponent;
